/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//Quick View

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }


function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }


//Quick View
var Currency = /*#__PURE__*/function () {
    function Currency() {
      _classCallCheck(this, Currency);
    }

    _createClass(Currency, null, [{
      key: "formatMoney",
      value:
      /**
       * Format money values based on your shop currency settings
       *
       * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
       * @param  {String} format - shop money_format setting
       * @return {String} value - formatted value
       */
      function formatMoney(cents, format) {
        if (typeof cents === 'string') {
          cents = cents.replace('.', '');
        }

        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}';

        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ',');
          decimal = defaultTo(decimal, '.');

          if (isNaN(number) || number == null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);
          var parts = number.split('.'),
              dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
              centsAmount = parts[1] ? decimal + parts[1] : '';
          return dollarsAmount + centsAmount;
        }

        var value = '';

        switch (formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;

          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;

          case 'amount_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;

          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, ',', '.');
            break;

          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;

          case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        }

        if (formatString.indexOf('with_comma_separator') !== -1) {
          return formatString.replace(placeholderRegex, value).replace(',00', '');
        } else {
          return formatString.replace(placeholderRegex, value).replace('.00', '');
        }
      }
    }]);

    return Currency;
  }();
 

function quickView() {
    $(".quick-view").click((function() {
      console.log('inner quickview')
        0 == $("#quick-view").length && $("body").append('<div id="quick-view"></div>');
        var t = $(this).data("handle");
        $("#quick-view").addClass(t), jQuery.getJSON("/products/" + t + ".js", (function(e) {
            var a = e.title;
            var o = e.type;
            var s = 0;
            var r = 0;
            var c = e.description;
            var n = e.images;
            var l = e.variants;
            var p = e.options;
            var v = "/products/" + t;
            $(".qv-add-button").html("Add to Cart - "+Currency.formatMoney(l[0].price, window.theme.moneyFormat))
            $(".qv-product-title").text(a), $(".qv-product-type").text(o), $(".qv-product-description").html(c), $(".qv-product-price").html(Currency.formatMoney(l[0].price, window.theme.moneyFormat)), $(".qv-product-original-price").html(Currency.formatMoney(l[0].compare_at_price, window.theme.moneyFormat)), l[0].compare_at_price > l[0].price && $(".qv-product-original-price").removeClass("hide"), l[0].available || $(".qv-add-button").prop("disabled", !0).html("Sold Out"), $(".view-product").attr("href", v);
            var u = $(n).length;
            $(n).each((function(t, e) {
                if (t == u - 1) {
                    var a = '<div><img src="' + e + '"></div>';
                    a = a.replace(".jpg", "_800x.jpg").replace(".png", "_800x.png"), $(".qv-product-images").append(a), $(".qv-product-images").slick({
                        dots: !1,
                        arrows: !0,
                        respondTo: "min",
                        useTransform: !1
                    }).css("opacity", "1")
                } else a = (a = '<div><img src="' + e + '"></div>').replace(".jpg", "_800x.jpg").replace(".png", "_800x.png"), $(".qv-product-images").append(a)
            }));
            var h = new Array;
            if (h.push("Size"), h.push("Color"), h.push("Colour"), h.length > 0) {
                var f = ".png",
                    g = !1,
                    m = !1,
                    q = 0,
                    w = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
                d = window.asset_url.substring(window.asset_url.lastIndexOf("?"), window.asset_url.length);
                var y = e;
                for (i = 0; i < y.options.length; i++) {
                    var b = "";
                    if (b = "object" == typeof y.options[i] ? y.options[i].name : y.options[i], g = !1, m = !1, h.indexOf(b) > -1) {
                        g = !0, q = i;
                        var x = b.toLowerCase();
                        if (/color|colour/i.test(x) && (m = !0), g) {
                            var k;
                            var C;
                            var _ = "",
                                S = y.variants[0].options[i];
                            _ += '<div class="swatch optiondd' + y.options[i].values.length + " " + x + ' clearfix" data-option-index="' + q + '">', _ += '<div class="header"><span>' + b + ": </span>" + S + "</div><div>";
                            var O = new Array;
                            for (j = 0; j < y.variants.length; j++) {
                                var z = y.variants[j];
                                var F = z.featured_image;
                                var L = z.options[q],
                                    M = L.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-"),
                                    T = "swatch-" + q + "-" + M;
                                O.indexOf(L) < 0 && (_ += '<div data-value="' + L + '" class="swatch-element ' + (m ? "color" : "") + M + (z.available ? " available " : " soldout ") + '">', m && (_ += '<div class="tooltip">' + L + "</div>"), _ += '<input id="' + T + '" type="radio" name="option-' + q + '" value="' + L + '"' + (0 == j ? " checked " : "") + (z.available ? "" : " disabled11") + "/>", m ? (_ += '<label for="' + T + '" class="img"><img src="' + F + '" />', _ += '<img class="crossed-out" src="https://cdn.shopify.com/s/files/1/0549/1802/1357/files/soldout.png?v=1637572754" />', _ += "</label>") : (_ += '<label for="' + T + '">' + L, _ += '<img class="crossed-out" src="https://cdn.shopify.com/s/files/1/0549/1802/1357/files/soldout.png?v=1637572754" />', _ += "</label>"), _ += "</div>", O.push(L))
                            }
                            _ += "</div></div>", $(".qv-product-swatch").append(_)
                        }
                    }
                }
            }
            var A = "";
            for (A += '<select id="product-select-qv" name="id" style="display: none;">', i = 0; i < e.variants.length; i++) {
                var E = e.variants[i];
                A += '<option data-sold="' + E.available + '" value="' + E.id + '" data-cqprice="' + E.compare_at_price + '" data-qprice="' + E.price + '">' + E.title + "</option>"
            }
            A += "</select>", $(".qv-product-variant").append(A);
            var I = "";
            for (i = 0; i < e.options.length; i++) {
                var Q = e.options[i];
                for (I += '<div class="select_quick', Q.values.length < 2 ? I += ' hide">' : I += '">', I += "<lable >" + Q.name + ":</lable>", I += '<select id="product-select-qv-opt-' + i + '" class="product-select-qv ' + Q.name.toLowerCase().replace(/ /g, "-") + '" >', j = 0; j < Q.values.length; j++) {
                    var R = Q.values[j];
                    I += '<option value="' + R + '">' + R + "</option>"
                }
                I += "</select></div>"
            }
            $(".qv-product-options").append(I), $('.swatch-element input[type="radio"]').change((function() {
                var t = jQuery(this).val();
                $(this).closest(".swatch").hasClass("color") && ($(this).closest(".swatch").find(".header").html("<span>Color: </span>" + t), $(this).closest(".qv-add-to-cart").find(".qv-product-options select.product-select-qv.color").val(t).change()), $(this).closest(".swatch").hasClass("size") && ($(this).closest(".swatch").find(".header").html("<span>Size: </span>" + t), $(this).closest(".qv-add-to-cart").find(".qv-product-options select.product-select-qv.size").val(t).change())
            })), $(".product-select-qv").change((function() {
                if (1 == e.options.length) var t = $("#product-select-qv-opt-0").val();
                else if (2 == e.options.length) var t = $("#product-select-qv-opt-0").val() + " / " + $("#product-select-qv-opt-1").val();
                $("#product-select-qv option").filter((function() {
                    return $(this).text() == t
                })).prop("selected", !0), $("#product-select-qv option").trigger("change");
                var a = $("#product-select-qv option").filter((function() {
                    return $(this).text() == t
                })).attr("data-qprice");
                var i = $("#product-select-qv option").filter((function() {
                    return $(this).text() == t
                })).attr("data-cqprice");
                var o;
                $(".qv-product-price").html(Currency.formatMoney(a, window.theme.moneyFormat)), $(".qv-product-original-price").html(Currency.formatMoney(i, window.theme.moneyFormat)), "null" !== i && i > a ? $(".qv-product-original-price").removeClass("hide") : $(".qv-product-original-price").addClass("hide"), "true" == $("#product-select-qv option").filter((function() {
                    return $(this).text() == t
                })).attr("data-sold") ? $(".qv-add-button").prop("disabled", !1).html("Add to Cart - "+Currency.formatMoney(a, window.theme.moneyFormat)) : $(".qv-add-button").prop("disabled", !0).html("Sold Out")
            }))
        })), $.fancybox({
            href: "#quick-view",
            maxWidth: 900,
            maxHeight: 500,
            fitToView: !0,
            width: "80%",
            height: "100%",
            autoSize: !1,
            closeClick: !1,
            openEffect: "none",
            closeEffect: "none",
            beforeLoad: function() {
                var t = $("#quick-view").attr("class");
              $(document).on("click", ".qv-add-button", (function() {
                var t = 1;
                var e;

                function a(t, e) {
                  jQuery.post("/cart/add.js", {
                    quantity: e,
                    id: t
                  }, null, "json").done((function() {
                    //$(".qv-add-to-cart-response").addClass("success").html("<span>" + $(".qv-product-title").text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>'), $(".fancybox-close").click(), $(".cart-link").click()
                    //window.location.href = '/cart';
                    $(".fancybox-close").click();

                    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                      bubbles: true,
                      detail: {
                        variant: t,
                        quantity: e
                      }
                    }));

                  })).fail((function(t) {
                    var e = t.responseJSON;
                    $(".qv-add-to-cart-response").addClass("error").html("<span><b>ERROR: </b>" + e.description)
                  }))
                }
                a($(this).closest(".qv-add-to-cart").find("#product-select-qv").val(), t)
              })), $(".fancybox-wrap").css("overflow", "hidden !important")
            },
            afterShow: function() {
                $("#quick-view").hide().html(content).css("opacity", "1").fadeIn((function() {
                    $(".qv-product-images").addClass("loaded")
                }))
            },
            afterClose: function() {
                $("#quick-view").removeClass().empty(), $(".qv-product-options select").val("").change(), $(".qv-product-options select").val(!1).trigger("change")
            }
        })
    }))
}
$(document).ready((function() {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done((function() {
    console.log('ready quickview');  
    quickView()
  }));
})), $(window).resize((function() {
    $("#quick-view").is(":visible") && $(".qv-product-images").slick("setPosition")
})), $(window).scroll((function() {
    $(this).scrollTop() > 150 ? $(".site-header-wrapper").addClass("sticky-head") : $(".site-header-wrapper").removeClass("sticky-head")
}));
 
$( window ).on( "load", function() {
    $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done((function() {
    console.log('ready11 quickview');  
    quickView()
  }));
  $('.quick-cart').click(function(){
    $(this).closest('.quick-add').toggleClass("active");
  })
});
// $(window).resize(function () {

//   if ($('#quick-view').is(':visible')) {

//     $('.qv-product-images').slick('setPosition');

//   }

// });



// $(window).resize(function () {

//   if ($('#quick-view').is(':visible')) {

//     $('.qv-product-images').slick('setPosition');

//   }

// });

$(document).ready(function(jQuery) {
  if($('.accordion-header').length > 0){
     $('.accordion-header').click(function() {
      const content = $(this).next('.accordion-content');
      content.slideToggle();
      $(this).toggleClass('active');
      $('.accordion-content').not(content).slideUp();
      $('.accordion-header').not(this).removeClass('active');
    });
  }
});